import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {AppComponent} from '../../app.component';

@Component({
  template : '<router-outlet></router-outlet>'
})
export class LanguageComponent extends AppComponent implements OnInit {
  private subscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute) {
    // @ts-ignore
    super();
  }

  ngOnInit() {
    this.subscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        this.changeLang(param.lang);
      });
  }
}
